import React from "react";

import { ENTRY_DATA_SECTION_KEYS } from "@frontend/common";

import { DealLaScSection } from "@/types/dealLaSc.types";
import TableDragDivider from "@FillInTableContainer/shared/components/TableDragDivider/TableDragDivider";
import useCheckIsDisplayTableDragDivider from "@FillInTableContainer/shared/hooks/useCheckIsDisplayTableDragDivider";
import { useGetNumberOfTable } from "@FillInTableContainer/shared/hooks/useGetNumberOfTable";
import { useHandleTableCreatorTableDrag } from "@FillInTableContainer/shared/hooks/useHandleTableCreatorTableDrag";
import { TableCreatorSubGroupTableList } from "@FillInTableContainer/shared/types/tableCreator.types";
import { newArrayToCountValue } from "@utils/newArrayToCountValue";

import DealLaScRightsScopeTable from "./components/DealLaScRightsScopeTable/DealLaScRightsScopeTable";
import * as S from "./DealLaScRightsScopeGroupTable.style";

interface Props {
  groupTableKey: DealLaScSection;
  tableList: TableCreatorSubGroupTableList;
  groupTableIndex: number;
}

const DealLaScRightsScope = ({
  groupTableIndex,
  groupTableKey,
  tableList,
}: Props) => {
  const articleSection = ENTRY_DATA_SECTION_KEYS.dealsLaSc;
  const { tableCount } = useGetNumberOfTable(articleSection);

  const { handleDragOver, draggedIndexInfo, isDraggingTable } =
    useHandleTableCreatorTableDrag(articleSection);
  const { isLastTable, handleCheckDragDividerDisplay } =
    useCheckIsDisplayTableDragDivider();

  return (
    <S.TableCreatorTableListWrapper isDisableEdit={false}>
      {tableList.map(({ tableKey, groupShellSectionList }) => {
        return newArrayToCountValue(tableCount(groupTableKey)).map(
          (_, multiTableIndex) => {
            return (
              <S.DraggableTableWrapper
                key={`table-${String(groupTableIndex)}-${String(
                  multiTableIndex,
                )}`}
                isTargetDraggingTable={
                  isDraggingTable && draggedIndexInfo[0] !== multiTableIndex
                }
                onDragOver={(e) => handleDragOver(e, multiTableIndex)}
              >
                <TableDragDivider
                  isDraggingEndPosition={handleCheckDragDividerDisplay({
                    moveDragIndex: draggedIndexInfo[1],
                    startDragIndex: draggedIndexInfo[0],
                    tableIndex: multiTableIndex,
                    currentGroupTableKey: groupTableKey,
                    isDraggingTable,
                  })}
                />
                <DealLaScRightsScopeTable
                  key={`table-${String(groupTableIndex)}-${String(
                    multiTableIndex + 1,
                  )}`}
                  tableKey={tableKey}
                  groupShellSectionList={groupShellSectionList}
                  groupTableKey={groupTableKey}
                  groupTableIndex={groupTableIndex}
                  tableIndex={multiTableIndex}
                  tableCount={tableCount(groupTableKey)}
                />
                {isLastTable(multiTableIndex, groupTableKey) && (
                  <TableDragDivider
                    isDraggingEndPosition={handleCheckDragDividerDisplay({
                      moveDragIndex: draggedIndexInfo[1],
                      startDragIndex: draggedIndexInfo[0],
                      tableIndex: multiTableIndex,
                      currentGroupTableKey: groupTableKey,
                      isDraggingTable,
                      lastIndex: newArrayToCountValue(tableCount(groupTableKey))
                        .length,
                    })}
                  />
                )}
              </S.DraggableTableWrapper>
            );
          },
        );
      })}
    </S.TableCreatorTableListWrapper>
  );
};

export default DealLaScRightsScope;
